// eslint-disable-next-line
import { types, NAME } from './reducer'
import { MATCHING } from "../../constants/matching";
import { MISSMATCHING } from "../../constants/missmatching";
const lang = document.documentElement.lang.slice(0, 2); 
export const actions = {
  getSubscription: () => ({
    //
  }),
  startPreExersize: () => (dispatch, getState) => {
    dispatch(actions.generateNewLettersMatrix())
    dispatch({
      type: "PREEXERSIZE"
    })
  },
  highlightElement: () => ({
    type: "HIGHLIGHT"
  }),
  incrementCountDown: () => ({
    type: "INCREMENT_COUNTDOWN"
  }),
  increment: () => ({
    type: "INCREMENT"
  }),
  setIncrementCountDown: (newCountDown) => ({
    type: "SET_INCREMENT_COUNT_DOWN",
    newCountDown
  }),
  startGame: (newCountDown) => (dispatch, getState) => {
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "START_GAME",
      newCountDown
    })
  },
  gameOverAction: () => (dispatch, getState) => {
    dispatch({
      type: "GAME_OVER"
    })
  },
  showAutoHelp: () => (dispatch, getState) => {
    let state = getState().WORD_PAIRS
    while(state.autoHelp.list[state.autoHelp.index].used) {
      state.autoHelp.index++      
    }
    state.gameMatrix[state.autoHelp.list[state.autoHelp.index].rowIndex][state.autoHelp.list[state.autoHelp.index].columnIndex].animation = 'wordPairsHelper'
    state.autoHelp.list[state.autoHelp.index].used = true
    dispatch({
      type: "SHOW_AUTO_HELP"
    })
  },
  setAutoHelp: (newLeftToFind) => (dispatch, getState) => {    
    let state = getState().WORD_PAIRS
    if(state.autoHelp.timer) {
      clearTimeout(state.autoHelp.timer)
    }
    let timeOut = 15000
    let leftToFind = newLeftToFind? newLeftToFind : state.leftToFind
    if(leftToFind <= state.autoHelp.remainingForAutoHelp) {
      timeOut = 5000
    }
    state.autoHelp.timer = setTimeout( () => {
      dispatch(actions.showAutoHelp())
    },timeOut)
    dispatch({
      type: "SET_AUTO_HELP"
    })
  },
  generateNewLettersMatrix: () => (dispatch, getState) => {
    let state = getState().WORD_PAIRS
    function shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;
    
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
    
      return array;
    }
    function initwordPairs(lang) {
      var mm = [];
      var m = [];
      var wpsMM = [];
      var wpsM = [];

      if (MISSMATCHING[lang]) {
        mm = MISSMATCHING[lang];
      } else {
        mm = MISSMATCHING["en"];
      }

      mm.forEach((word) => {
        let mismatching = {
          value: word,
          special: true,
        };

        let matching = {
          value: [word[0], word[0]],
          special: false,
        };
        wpsMM.push(mismatching);
        wpsM.push(matching);
      });

      if (MATCHING[lang]) {
        m = MATCHING[lang];
      } else {
        m = MATCHING["en"];
      }

      m.forEach((word) => {
        let matching = {
          value: [word, word],
          special: false,
        };
        wpsM.push(matching);
      });

      wpsM = shuffle(wpsM);
      wpsMM = shuffle(wpsMM);
      wpsM = wpsM.slice(0, 14);
      wpsMM = wpsMM.slice(0, 10);
      var wps = shuffle(wpsM.concat(wpsMM));
      let newMatrix = []
      let k = 0
      let newList = []
      for (let i = 0; i < 6; i++) {
        let newRow = []
        for (let j = 0; j < 4; j++, k++) {
          if(wps[k].special) {
            newList.push({
              rowIndex: i,
              columnIndex: j,
              used: false
            })
          }
          newRow.push(wps[k])
        }
        newMatrix.push(newRow)
      }      
      shuffle(newList)
      state.autoHelp.list = newList
      state.autoHelp.index = 0
      return newMatrix;
    }
    dispatch({
      type: "GENERATE_MATRIX",
      gameMatrix: initwordPairs(lang), //newMatrix,
      leftToFind: 10,
      autoHelp: state.autoHelp
    })
  },
  showGameOverScreanAction: () => ({
    type: "SHOW_GAME_OVER_SCREAN"
  }),
  cellClickAction: (rowIndex, columnIndex, value) => (dispatch, getState) => {
    let state = getState().WORD_PAIRS
    let newMatrix = state.gameMatrix
    let newPoints = state.points;
    let newWrongAnswers = state.wrongAnswers
    let newTimeLeft = state.timeLeft
    let newStep = state.exersizeState
    let newLeftToFind = state.leftToFind
    if (!newMatrix[rowIndex][columnIndex].isUsed) {
      if (newMatrix[rowIndex][columnIndex].special) {
        newMatrix[rowIndex][columnIndex].isUsed = true
        newMatrix[rowIndex][columnIndex].animation = 'greenAnimation'
        newPoints += state.POINTS_PER_CLICK
        newLeftToFind--
        if (newLeftToFind <= 0) {
          dispatch(actions.newRound())
          let state = getState().WORD_PAIRS
          newMatrix = state.gameMatrix
          newLeftToFind = state.leftToFind
        }
        //----------------------------------------------marck as used it helpers list-----------
        for( let i =0 ; i<state.autoHelp.list.length;i++) {
          if(state.autoHelp.list[i].rowIndex === rowIndex && state.autoHelp.list[i].columnIndex === columnIndex) {
            state.autoHelp.list[i].used = true
          }
        }
        dispatch(actions.setAutoHelp(newLeftToFind))
        //----------------------------------------------------------------------------------------------
      } else {
        //---------------------------------------------------------------For correct animation of one Letter
        if (newMatrix[rowIndex][columnIndex].animation === 'redAnimation') {
          newMatrix[rowIndex][columnIndex].animation = 'redAnimationSecond'
        } else {
          newMatrix[rowIndex][columnIndex].animation = 'redAnimation'
        }
        //-----------------------------------------------------------------------------------------------------------------
        newWrongAnswers++
        if (newTimeLeft > 5) {
          newTimeLeft -= 5
        } else {
          newStep = 'gameOver';
          newTimeLeft = -1;
        }
      }
    }
    dispatch({
      type: "CELL_CLICK",
      gameMatrix: newMatrix,
      points: newPoints,
      wrongAnswers: newWrongAnswers,
      timeLeft: newTimeLeft,
      exersizeState: newStep,
      leftToFind: newLeftToFind,
      autoHelp: state.autoHelp
    })
  },
  newRound: () => (dispatch, getState) => {
    let state = getState().WORD_PAIRS
    dispatch(actions.generateNewLettersMatrix())    
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "NEW_ROUND",
      currentRound: state.currentRound + 1
    })
  }
}
